import {useState, useRef, useEffect} from "react";

/**
 * Dropdown button that displays a list of options when clicked
 *
 * @param props.options String options that a button has
 * @param props.button Object that contains button id(string), text(string), action(function).
 * @param props.prefix String that is affixed to options.
 * @param props.displayLoading  Function that performs actions while data is loading.
 * @return JSX
 */
export function CdaWebModalDropdownButton(props) {
    const [isOpen, setIsOpen] = useState(false);
    const {options, button, prefix, displayLoading} = props;
    const dropdownRef = useRef(null);
    const isSingleItem = options.length === 1;


    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleClick = (type) => {
        if(displayLoading)
        {
            displayLoading();
        }

        if (button.action) {
            button.action(type);
        }
        setIsOpen(false);
    };

    const handleClickOutside = (event) => {
        const isPillClicked = event.target.id === "dropdownbutton" || event.target.parentElement?.id === "dropdownbutton";

        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            if (!isPillClicked) {
                setIsOpen(false);
            }
        }
    };


    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
      <div>
        {isSingleItem &&
         (
             <button
               key={button.text}
               className={`cdaWebModalButton`}
               onClick={()=>handleClick(options[0])}>{button.text}
             </button>
         )}

         {!isSingleItem &&
           (
             <div
               className = {"cdaWebModalDropdownButtonContainer cdaWebModalDropdownButton"}
               ref={dropdownRef}
               onClick={()=>toggleDropdown()}><span>{button.text + ' ▼'}</span>
               {isOpen && (
                 <div id="dropdownbutton" className={`cdaWebModalDropdownListContainer ${isOpen ? 'cdaWebModalDropdownListContainerOpen' : ''}`}>
                   <ul className="cdaWebModalDropdownList">
                     {options.map((option) => (
                       <li key={option} onClick={()=>handleClick(option)}>
                         {`${prefix} ${option.toUpperCase()}`}
                       </li>))
                     }
                   </ul>
                 </div>)}
             </div>
           )}
      </div>
  );
}
